/** Shared layout tokens for playable event tiles (My Events / Nearby). */

export const EVENT_CARD_AVATAR_SIZE = {
  narrow: 64,
  wide: 80
}

export const EVENT_CARD_ACTION_WIDTH = {
  narrow: 86,
  wide: 96
}

export const EVENT_CARD_MAIN_GAP = {
  narrow: 10,
  wide: 12
}

export const HOST_END_ICON_SIZE = 18

export const joinButtonSx = (compact) => ({
  textTransform: 'none',
  fontWeight: 700,
  borderRadius: 999,
  width: '100%',
  px: compact ? 1.6 : 2.2,
  py: compact ? 0.85 : 1,
  fontSize: compact ? '0.86rem' : '0.95rem',
  background: 'linear-gradient(135deg, #22C55E 0%, #16A34A 100%)',
  boxShadow: '0 4px 12px rgba(34, 197, 94, 0.3)',
  '&:hover': {
    background: 'linear-gradient(135deg, #16A34A 0%, #15803D 100%)',
    boxShadow: '0 6px 16px rgba(34, 197, 94, 0.4)'
  }
})

/** Plain <button> styles — one block, easy to tweak in DevTools */
export const hostEndButtonSx = (tone) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '4px',
  margin: 0,
  padding: 0,
  border: 'none',
  background: 'none',
  cursor: 'pointer',
  fontFamily: 'inherit',
  fontSize: '0.75rem',
  fontWeight: 500,
  lineHeight: 1,
  color: tone === 'close' ? 'rgba(253,186,116,0.9)' : 'rgba(252,165,165,0.88)',
  '&:hover': {
    textDecoration: 'underline',
    color: tone === 'close' ? '#FDBA74' : '#FCA5A5'
  },
  '&:disabled': {
    cursor: 'default',
    opacity: 0.45,
    textDecoration: 'none'
  }
})
